<template>
<!-- 
  TODO:
  Kannst du noch ein VOverlay drüber legen? Dann bekommen wir den Hover-Effekt wieder so schön wie ursprünglich. Für die Ein/Ausblendeffekte kannst du vermutlich ein VExpandTransition verwenden.

-->
 <v-hover>
    <template v-slot:default="{ hover }">
      <v-card
        class="mx-auto card-outter"
        max-width="344"
        height="350"
        v-bind="$attrs"
      >
        <v-img 
        :aspect-ratio="16/9"
        class="white--text align-end"
        height="200px"
        :src="cImgUrl">
          <!--<v-card-title ><span class="card-title-color">{{item.title}}</span></v-card-title>-->
        </v-img>
        <v-card-title class="text-center">{{item.title}}</v-card-title>

        <v-card-actions class="card-actions">
           <v-icon>mdi-tag-multiple</v-icon>{{getCategoriesAsString(item.category)}}
        </v-card-actions>

        <v-fade-transition>
          <v-overlay
            v-if="hover"
            absolute
            color="#FFFFFF"
          >
            <!-- <v-btn>Mehr Informationen <br>anzeigen</v-btn>-->
          </v-overlay>
        </v-fade-transition>
      </v-card>
    </template>
  </v-hover>
<!--
  <v-card
      style="height: 100%"
      v-bind="$attrs"
  >
    <v-img
      :src="cImgUrl"
      class="black--text align-end"
      height="200px"
      cover>
      <v-card-title>{{ item.title }}</v-card-title>
    </v-img>
  </v-card>
  -->
</template>

<script>

import {helper} from '@/mixins/helper.js'
import {categoryBase} from '@/mixins/categoryBase.js'
export default {
    name: 'GhShopListItem',
    mixins:[helper,categoryBase],
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    },
    computed:{
    cImgUrl () {
        return this.item.img ? this.getModifiedImage(this.item.img) : "/images/heart.png"
    }
}
}
</script>

<style scoped>
.card-outter {
  position: relative;
  padding-bottom: 50px;
}
.card-actions {
  position: absolute;
  bottom: 0;
  font-size: small;
}
.card-title-color{
  /*background-color: #ee44aad1;*/
  width:100%;
  text-align: center;
}
.v-card__title{
  width:100%;
  font-weight: 300;
  /*
  background-color: black;
  opacity:0.5;
  */
}
</style>
